// import {} from '@mantine/core'
import { IconTrekking } from '@tabler/icons-react'
import * as Types from '../../declarations'
// import PictureGroupTwoLine from './components/PictureGroupTwoLine'
import { formatNumberOrRange } from '../../lib/display'
// import { useIsMobile } from '../../lib/useIsMobile'
import pluralize from 'pluralize'
import SectionHeader from './components/SectionHeader'
import HTMLContent from 'components/HTMLContent'

interface Props {
	trip: Types.DB.Models.TripAttributes
}

const Variations = ({
	trip: {
		name,
		jsonData: { variations },
	},
}: // trip,
Props) => {
	if (!variations || (variations?.length ?? 0) === 0) return <></>

	// const defaultAltText = getTrekImageAltText(
	// 	trip,
	// 	'variations and side trips',
	// )
	// const isMobile = useIsMobile()

	return (
		<div id="variations-wrapper" className="spacing-between-sections-above">
			<SectionHeader
				title={`${name} Variations & Side trips`}
				section={Types.App.DataTypes.FeedbackSection.VARIATIONS}
			/>

			<p>
				These are variations on the typical route. Which could be added on;
				either part way along or at the start / end to extend the trek.
			</p>

			<div id="variations-items">
				{variations.map((item, key) => {
					return (
						<div className="variations-item" key={key}>
							<div>
								<h3>{item.name}</h3>
								{item?.daysExtra?.length > 0 && (
									<h4>
										add&nbsp;
										{formatNumberOrRange(item.daysExtra)} extra{' '}
										{pluralize('day', item.daysExtra?.[0])}
										<IconTrekking size="1rem" />
									</h4>
								)}
							</div>

							{/* disabling pictures for now until we have a solution for more legit
			pictures */}
							{/*<Grid>
								
								 <Grid.Col span={{base: 12, sm: 3}}>
									
									<div className="pics-column">
										{item?.pictures && (
											<PictureGroupTwoLine
												pictures={item.pictures.slice(0, 4)}
												hideSecondLine={isMobile}
												defaultAltText={defaultAltText}
											/>
										)}
									</div>
								</Grid.Col>
								<Grid.Col span={{base: 12, sm: 9}}> */}
							<HTMLContent html={item.description}></HTMLContent>
							{/* </Grid.Col>
							</Grid> */}

							{/*}
									<div className="variations-item-row">
										{item?.pictures && (
											<div className="pics-column">
												<PictureGroupTwoLine
													pictures={item.pictures.slice(0, 4)}
													hideSecondLine={isMobile}
													defaultAltText={defaultAltText}
												/>
											</div>
										)}
										<div className="remainder">
											<div
												dangerouslySetInnerHTML={{ __html: item.description }}
											></div>
										</div>
									</div>
										*/}
						</div>
					)
				})}
			</div>
		</div>
	)
}

export default Variations
